// customElements.get("show-more-button") ||
//   customElements.define(
//     "show-more-button",
//     class extends HTMLElement {
//       constructor() {
//         super();
//         const button = this.querySelector("button");
//         button &&
//           button.addEventListener("click", (event) => {
//             event.preventDefault();
//             event.stopPropagation();
//             event.stopImmediatePropagation();
//             this.expandShowMore(event);
//             const details = button.closest("details");
//             if (details) {
//               details.open = !0;
//               requestAnimationFrame(() => (details.open = !0));
//               setTimeout(() => (details.open = !0), 0);
//               setTimeout(() => (details.open = !0), 40);
//               details.setAttribute("open", "open");
//             }
//           });
//       }
//       expandShowMore(event) {
//         const button = event.currentTarget;
//         const displayEl = button.closest(".parent-display");
//         if (!displayEl) return;

//         const items = Array.from(
//           displayEl.querySelectorAll(".show-more-item")
//         );
//         if (!items.length) return;

//         const expanding = items[0].classList.contains("hidden");

//         items.forEach((item) => item.classList.toggle("hidden", !expanding));

//         const labelMore = this.querySelector(".label-show-more");
//         const labelLess = this.querySelector(".label-show-less");
//         labelMore && labelMore.classList.toggle("hidden", expanding === true);
//         labelLess && labelLess.classList.toggle("hidden", expanding === false);

//         if (expanding) {
//           const nextElementToFocus = items.find(
//             (item) => !item.classList.contains("hidden")
//           );
//           const input = nextElementToFocus?.querySelector("input");
//           input && input.focus();
//         }
//       }
//     }
//   );
// //# sourceMappingURL=/s/files/1/0718/8863/4080/t/1/assets/show-more.js.map?v=1725480399

customElements.get("show-more-button") ||
  customElements.define(
    "show-more-button",
    class extends HTMLElement {
      constructor() {
        super();
        const button = this.querySelector("button");
        if (button) {
          button.addEventListener("click", this.handleClick.bind(this));
        }
      }

      handleClick(event) {
        // Prevent default and stop propagation
        event.preventDefault();
        event.stopPropagation();

        const button = event.currentTarget;
        const details = button.closest("details");

        // Immediately prevent details from closing
        if (details) {
          const wasOpen = details.open;

          // Use a small timeout to allow the click to process
          setTimeout(() => {
            this.expandShowMore(button);
            // Force details to stay open
            if (wasOpen) {
              details.open = true;
              details.setAttribute("open", "");
            }
          }, 0);
        } else {
          this.expandShowMore(button);
        }
      }

      expandShowMore(button) {
        const displayEl = button.closest(".parent-display");
        if (!displayEl) {
          // console.log("No parent-display found");
          return;
        }

        const items = Array.from(displayEl.querySelectorAll(".show-more-item"));
        if (!items.length) {
          // console.log("No show-more-item elements found");
          return;
        }

        // console.log("Found items:", items.length);

        // Check if we're expanding or collapsing based on first item
        const firstItem = items[0];
        const isExpanding = firstItem.classList.contains("hidden");

        // console.log("Is expanding:", isExpanding);

        // Toggle visibility
        items.forEach((item) => {
          if (isExpanding) {
            item.classList.remove("hidden");
          } else {
            item.classList.add("hidden");
          }
        });

        // Toggle button labels
        const labelMore = this.querySelector(".label-show-more");
        const labelLess = this.querySelector(".label-show-less");

        if (labelMore && labelLess) {
          if (isExpanding) {
            labelMore.classList.add("hidden");
            labelLess.classList.remove("hidden");
          } else {
            labelMore.classList.remove("hidden");
            labelLess.classList.add("hidden");
          }
        }

        // Focus on first newly visible item if expanding
        if (isExpanding) {
          const firstVisibleItem = items.find(
            (item) => !item.classList.contains("hidden")
          );
          const input = firstVisibleItem?.querySelector("input");
          if (input) {
            input.focus();
          }
        }
      }
    }
  );
